"use strict";
//Lors du changement de valeur du select, on soumet le formulaire
document.addEventListener('DOMContentLoaded', function () {
    var formSubmitElements = document.querySelectorAll('.js-submit-select-change');
    if (formSubmitElements != null && formSubmitElements.length > 0) {
        for (var i = 0; i < formSubmitElements.length; i++) {
            var selectElements = formSubmitElements[i].querySelectorAll('select');
            if (selectElements != null && selectElements.length > 0) {
                for (var j = 0; j < selectElements.length; j++) {
                    selectElements[j].addEventListener('change', function (event) {
                        var currentElement = event.currentTarget;
                        var form = currentElement.form;
                        if (form != null) {
                            form.submit();
                        }
                    });
                }
            }
        }
    }
}, false);
